if ($('div').hasClass('errors')) {
  $('div.errors').hide();
  $('input[type="email"], input[type="password"]').addClass('error');
  $('input[type="email"].error').attr('placeholder', 'INCORRECT LOGIN');
  $('input[type="password"].error').attr('placeholder', 'INCORRECT PASSWORD');
  $('input.error').each(function() {
    $(this).focus(function() {
      $(this).css('border', '1px solid #ddd');
      $(this).attr('placeholder', '');
    });
    $(this).click(function() {
      $(this).css('border', '1px solid #ddd');
      $(this).attr('placeholder', '');
    });
  });
}

$('.grid.added-grid:not(:first)').find('.col-sm-6:nth-of-type(2) p').hide();